module.exports = __webpack_public_path__ + "img/reset-step-six.0c8326a7.png";